import React from "react";
import { Sidebar } from "../../features/operational-map";
import { OperationalMapProvider } from "../../providers/OperationalMapProvider";
import Map from "../../features/operational-map/components/Map/Map";
import { MapSettingsProvider } from "../../features/operational-map/context/MapSettingsContext";

function OperationalMap() {
  return (
    <OperationalMapProvider>
      <MapSettingsProvider>
      <div className="h-screen pt-28 flex">
        <Sidebar sidebarType="non-emergency" key={"non-emergency"} />
        <div className="flex-1 relative">
          <Map />
        </div>
        <Sidebar sidebarType="emergency" key={"emergency"} />
      </div>
      </MapSettingsProvider>
    </OperationalMapProvider>
  );
}

export default OperationalMap;
